import { render } from "./UploadResultFiles.vue?vue&type=template&id=744af009"
import script from "./UploadResultFiles.vue?vue&type=script&lang=js"
export * from "./UploadResultFiles.vue?vue&type=script&lang=js"

import "./UploadResultFiles.vue?vue&type=style&index=0&id=744af009&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__